import { useState } from "react";
import { useNavigate } from "react-router-dom";

const ADMIN_PASSWORD = "Diyakira@123";
const SESSION_KEY = "ug_admin_auth";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  function handleSubmit(e) {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      sessionStorage.setItem(SESSION_KEY, "1");
      navigate("/admin/leads");
    } else {
      setError("Incorrect password. Please try again.");
      setPassword("");
    }
  }

  return (
    <div className="page-wrapper">
      <div className="brand-header">
        <a href="/"><img src="/logo.jpeg" alt="Uni Global Education Consultancy" className="brand-logo" /></a>
      </div>

      <div className="form-card" style={{ maxWidth: 380 }}>
        <form className="card-body" onSubmit={handleSubmit} noValidate>
          <h1 className="form-heading" style={{ fontSize: "1.3rem" }}>Admin Login</h1>
          <p className="form-subheading">Enter your password to view leads.</p>

          {error && <div className="server-error">{error}</div>}

          <div className="form-group" style={{ marginTop: 8 }}>
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Enter admin password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(""); }}
              autoFocus
            />
          </div>

          <button type="submit" className="btn-submit">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export { SESSION_KEY };
